import React from 'react';
import { Grid, Typography, makeStyles } from '@material-ui/core';
import { analyticsService } from '../../services';
import { RangeValue } from '../../constants/product.constant';
import StatCard from '../../components/analytics/StatCard';
import { Loadable, useAnalyticsData } from '../../components/analytics/tabHelpers';
import { fmtNum } from '../../components/analytics/format';

const useStyles = makeStyles(() => ({
  section: { fontSize: 16, fontWeight: 700, color: '#1f2937', margin: '8px 4px 0' },
  note: { color: '#9ca3af', fontSize: 13, margin: '4px' },
}));

const TeacherAppTab: React.FC<{ days: RangeValue }> = ({ days }) => {
  const classes = useStyles();
  const { loading, error, data } = useAnalyticsData<any>(() => analyticsService.getTeacherApp(days), [days]);

  const signups = data?.teacherSignups || {};
  const usage = data?.usage || {};

  return (
    <Loadable loading={loading} error={error}>
      <Grid container spacing={3}>
        <Grid item xs={12}><Typography className={classes.section}>Teacher signups</Typography></Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard label="Teachers (total)" value={fmtNum(signups.total)} />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard label="Signups (window)" value={fmtNum(signups.inWindow)} />
        </Grid>

        <Grid item xs={12}><Typography className={classes.section}>Teacher App usage</Typography></Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard label="Ever touched" value={fmtNum(usage.everTouched)} />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard label="Active (window)" value={fmtNum(usage.activeInWindow)} />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard label="Onboarded" value={fmtNum(usage.onboarded)} />
        </Grid>

        <Grid item xs={12}>
          <Typography className={classes.note}>
            Teacher App is early — most counts will be low until tutors onboard.
          </Typography>
        </Grid>
      </Grid>
    </Loadable>
  );
};

export default TeacherAppTab;
